type FontWeightType = {
	weight: string;
	url: string;
};

const primaryFontWeights: FontWeightType[] = [
	{ weight: "400", url: "regular" },
	{ weight: "500", url: "medium" },
	{ weight: "600", url: "semiBold" },
	{ weight: "700", url: "bold" },
	{ weight: "800", url: "extraBold" },
];

const secondaryFontWeights: FontWeightType[] = [{ weight: "700", url: "bold" }];

const loadFontVariations = (
	cdnUrl: string,
	weights: FontWeightType[],
	fontFamily: string,
	intent: "primary" | "secondary",
) => {
	weights.forEach((weight) => {
		const font = new FontFace(fontFamily, `url('${cdnUrl}/fonts/${fontFamily}/${weight.url}.woff2') format('woff2')`, {
			weight: weight.weight,
		});
		font
			.load()
			.then((loadedFont) => {
				document.fonts.add(loadedFont);
				if (intent === "primary") document.documentElement.style.setProperty("--font-primary", fontFamily);
				else document.documentElement.style.setProperty("--font-secondary", fontFamily);
			})
			.catch((e) => {
				console.warn("Failed to load font", e);
			});
	});
};

export const configFonts = (cdnUrl: string, primaryFonts: string, secondaryFonts: string) => {
	if (primaryFonts !== "Manrope") loadFontVariations(cdnUrl, primaryFontWeights, primaryFonts, "primary");
	if (secondaryFonts !== "Thicker") loadFontVariations(cdnUrl, secondaryFontWeights, secondaryFonts, "secondary");
};
